(function() {
  'use strict';
  var configNode=document.querySelector('[data-bag-config]');
  if(!configNode || !window.IndiaLivingCartOptions) return;
  var config=JSON.parse(configNode.textContent), core=window.IndiaLivingCartOptions;
  var root=window.Shopify?.routes?.root || '/', tail=Promise.resolve(), pending=0;
  function money(cents,currency) { return new Intl.NumberFormat(undefined,{style:'currency',currency:currency||'USD'}).format(cents/100); }
  function esc(value) { return String(value??'').replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  async function request(path,data) {
    var response=await fetch(root+path,data?{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)}:{cache:'no-store'});
    if(!response.ok) throw new Error('Cart update failed');
    return response.json();
  }
  function notice(text) { document.querySelectorAll('[data-options-status]').forEach(function(el){el.textContent=text;}); }
  function busy(value) {
    document.querySelectorAll('[data-bag-all],[data-bag-none],[data-bag-count],[data-express-request]').forEach(function(el){el.disabled=value;});
    document.querySelectorAll('[data-cotton-bag],[data-express]').forEach(function(el){el.setAttribute('aria-busy',String(value));});
  }
  async function reconcile(cart,selection) {
    var p=core.plan(cart,config,selection);
    if(Object.keys(p.updates).length) cart=await request('cart/update.js',{updates:p.updates});
    if(p.additions.length) { await request('cart/add.js',{items:p.additions}); cart=await request('cart.js'); }
    var attrs={};
    if(selection) attrs['Cotton bags']=p.all?'All rugs':'Selected rugs';
    if(Object.keys(attrs).some(function(k){return cart.attributes?.[k]!==attrs[k];})) cart=await request('cart/update.js',{attributes:attrs});
    return cart;
  }
  function render(cart) {
    var p=core.plan(cart,config), labels=config.labels;
    document.querySelectorAll('[data-bag-rows]').forEach(function(el){
      el.innerHTML=p.rows.length?p.rows.map(function(r){
        var variant=config.variants[core.tier(r.size.area)], d=p.desired.find(function(x){return x.properties._bag_for===r.ref;}), selected=d?.quantity||0;
        var title='<strong>'+esc(r.item.product_title)+'</strong><span>'+esc(r.item.variant_title)+' · '+r.item.quantity+' rug'+(r.item.quantity===1?'':'s')+'</span>';
        if(!r.eligible || !variant?.available) return '<div class="bag-choice">'+title+'<p>'+esc(labels.unknown)+'</p></div>';
        var opts='<option value="0">'+esc(labels.none)+'</option>';
        for(var n=1;n<=r.item.quantity;n++) opts+='<option value="'+n+'"'+(n===selected?' selected':'')+'>'+n+' bag'+(n===1?'':'s')+' · '+esc(money(variant.price*n,cart.currency))+'</option>';
        return '<label class="bag-choice">'+title+'<span>'+esc(money(variant.price,cart.currency))+' '+esc(labels.each)+'</span><select data-bag-count data-rug-ref="'+esc(r.ref)+'" data-rug-quantity="'+r.item.quantity+'">'+opts+'</select></label>';
      }).join(''):'<p>'+esc(labels.empty)+'</p>';
    });
    document.querySelectorAll('[data-bag-all]').forEach(function(el){el.hidden=!p.rows.some(function(r){return r.eligible;});el.textContent=p.all&&p.rows.every(function(r){return r.eligible&&p.desired.some(function(d){return d.properties._bag_for===r.ref;});})?labels.all_selected:labels.all;});
    document.querySelectorAll('[data-bag-none]').forEach(function(el){el.hidden=!cart.items.some(function(i){return Number(i.product_id)===Number(config.productId);});});
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:cart}));
  }
  async function renderPage() {
    var page=document.querySelector('[data-cart-page]'); if(!page) return;
    var response=await fetch(root+'cart?section_id='+encodeURIComponent(page.dataset.sectionId),{cache:'no-store'});
    if(!response.ok) throw new Error('Cart view failed');
    var html=new DOMParser().parseFromString(await response.text(),'text/html').querySelector('[data-cart-page]');
    if(!html) throw new Error('Cart view failed');
    var opened=Array.from(page.querySelectorAll('details[open]')).map(function(el){return el.hasAttribute('data-express')?'express':'bag';});
    page.replaceWith(html);
    opened.forEach(function(kind){var el=html.querySelector(kind==='bag'?'[data-cotton-bag]':'[data-express]');if(el)el.open=true;});
  }
  function run(action,selection,refreshPage) {
    pending++;busy(true);notice(config.labels.saving);
    var task=tail.catch(function(){}).then(async function(){
      var cart=await request('cart.js');
      if(action) cart=await action(cart);
      cart=await reconcile(cart,selection);
      if(refreshPage!==false) await renderPage();
      render(cart);notice(config.labels.saved);return cart;
    });
    tail=task;
    return task.catch(function(error){notice(config.labels.error);throw error;}).finally(function(){pending--;busy(pending>0);});
  }
  async function change(cart,key,quantity) {
    var line=cart.items.find(function(i){return i.key===key;}); if(!line)return cart;
    if(Number(line.product_id)===Number(config.productId)&&line.properties?._bag_for) await request('cart/update.js',{attributes:{'Cotton bags':'Selected rugs'}});
    return request('cart/change.js',{id:key,quantity:quantity});
  }
  window.IndiaLivingCart={run:run,request:request,change:change,render:render};
  document.addEventListener('click',function(event){
    var all=event.target.closest('[data-bag-all]'), none=event.target.closest('[data-bag-none]');
    if(!all&&!none)return;
    event.preventDefault();
    if(pending)return;
    var widget=event.target.closest('[data-cotton-bag]');
    run(none?async function(cart){var updates={};cart.items.forEach(function(i){if(Number(i.product_id)===Number(config.productId))updates[i.key]=0;});return request('cart/update.js',{updates:updates});}:null,{all:!!all}).then(function(){document.querySelector('[data-cart-page] [data-cotton-bag] summary')?.focus();}).catch(function(){});
  });
  document.addEventListener('change',function(event){
    var input=event.target;
    if(input.matches('[data-bag-count]')) {
      var ref=input.dataset.rugRef, count=Number(input.value);
      run(null,{all:false,ref:ref,count:count===Number(input.dataset.rugQuantity)?'all':count}).catch(function(){});
    }
  });
  document.addEventListener('submit',function(event){
    var form=event.target.closest('[data-cart-page] form');if(!form)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(pending)return;
    var checkout=event.submitter?.name==='checkout';
    var inputs=Array.from(form.querySelectorAll('[data-cart-line]'));
    if(inputs.some(function(el){return !el.checkValidity();})){form.reportValidity();return;}
    var values=inputs.map(function(el){return {key:el.dataset.cartLine,quantity:Number(el.value)};});
    run(async function(cart){var updates={};values.forEach(function(v){if(cart.items.some(function(i){return i.key===v.key;}))updates[v.key]=v.quantity;});return request('cart/update.js',{updates:updates});}).then(function(cart){if(checkout&&cart.item_count)location.assign(root+'checkout');}).catch(function(){});
  },true);
  document.addEventListener('click',function(event){
    var link=event.target.closest('[data-checkout]');if(!link)return;
    event.preventDefault();event.stopImmediatePropagation();
    run().then(function(cart){if(cart.item_count)location.assign(root+'checkout');}).catch(function(){});
  },true);
  run().catch(function(){});
})();
